(function () {
  'use strict';

  function parseSize(value) {
    var input = value.trim().toUpperCase().replace(/\s+/g, '');
    var metric = input.match(/^(?:P|LT)?(\d{3})\/(\d{2})(?:R|\/)(\d{2}(?:\.5)?)$/);
    var flotation = input.match(/^(\d{2}(?:\.\d+)?)X(\d{1,2}(?:\.\d+)?)R(\d{2}(?:\.5)?)$/);
    var width, sidewall, rim, diameter;

    if (metric) {
      width = Number(metric[1]) / 25.4;
      sidewall = width * Number(metric[2]) / 100;
      rim = Number(metric[3]);
      if (Number(metric[1]) < 105 || Number(metric[1]) > 455 || Number(metric[2]) < 25 || Number(metric[2]) > 95 || rim < 10 || rim > 26) return null;
      diameter = rim + sidewall * 2;
    } else if (flotation) {
      diameter = Number(flotation[1]);
      width = Number(flotation[2]);
      rim = Number(flotation[3]);
      if (diameter < 20 || diameter > 44 || width < 5 || width > 16 || rim < 10 || rim > 26 || diameter <= rim) return null;
      sidewall = (diameter - rim) / 2;
    } else {
      return null;
    }

    var circumference = diameter * Math.PI;
    return {
      diameter: diameter,
      width: width,
      rim: rim,
      sidewall: sidewall,
      circumference: circumference,
      revolutions: 63360 / circumference
    };
  }

  function signed(value, digits, unit) {
    var rounded = Number(value.toFixed(digits));
    return (rounded > 0 ? '+' : '') + rounded.toFixed(digits) + (unit || '');
  }

  function initCalculator(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    var form = root.querySelector('form');
    var error = root.querySelector('.adf-calc-error');
    var results = root.querySelector('.adf-calc-results');
    var visualizer = root.querySelector('.adf-calc-visualizer');
    var mode = 'metric';
    var unit = 'in';
    var current = null;
    var saved = { metric: null, inch: { stock: ['30', '9.5', '15'], new: ['31', '10.5', '15'] } };

    function inputs(which) {
      return ['a', 'b', 'c'].map(function (part) {
        return form.elements.namedItem(which + '-' + part);
      });
    }

    function values(which) {
      return inputs(which).map(function (input) { return input.value.trim(); });
    }

    function setValues(which, parts) {
      inputs(which).forEach(function (input, index) { input.value = parts[index]; });
    }

    function tire(which) {
      var parts = values(which);
      return parseSize(mode === 'metric'
        ? parts[0] + '/' + parts[1] + 'R' + parts[2]
        : parts[0] + 'x' + parts[1] + 'R' + parts[2]);
    }

    function put(name, value) {
      root.querySelectorAll('[data-result="' + name + '"]').forEach(function (element) {
        element.textContent = value;
      });
    }

    function selectButton(selector, activeAttribute, value) {
      root.querySelectorAll(selector).forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute(activeAttribute) === value));
      });
    }

    function display() {
      if (!current) return;
      var stock = current.stock;
      var next = current.next;
      var multiplier = unit === 'mm' ? 25.4 : 1;
      var suffix = unit === 'mm' ? ' mm' : ' in';

      ['diameter', 'width', 'sidewall', 'circumference'].forEach(function (key) {
        var digits = unit === 'mm' ? 0 : 1;
        put('stock-' + key, (stock[key] * multiplier).toFixed(digits) + suffix);
        put('new-' + key, (next[key] * multiplier).toFixed(digits) + suffix);
        put('diff-' + key, signed((next[key] / stock[key] - 1) * 100, 1, '%'));
      });
      put('stock-revolutions', stock.revolutions.toFixed(0));
      put('new-revolutions', next.revolutions.toFixed(0));
      put('diff-revolutions', signed(next.revolutions - stock.revolutions, 0));
      put('height-change', signed((next.diameter - stock.diameter) * multiplier / 2, unit === 'mm' ? 0 : 1, suffix));
      ['stock', 'new'].forEach(function (which) {
        var tire = which === 'stock' ? stock : next;
        put(which + '-size', current[which + 'Label']);
        put(which + '-visual-diameter', (tire.diameter * multiplier).toFixed(unit === 'mm' ? 0 : 1) + suffix);
        put(which + '-visual-width', (tire.width * multiplier).toFixed(unit === 'mm' ? 0 : 1) + suffix);
        put(which + '-visual-sidewall', (tire.sidewall * multiplier).toFixed(unit === 'mm' ? 0 : 1) + suffix);
        put(which + '-visual-rim', tire.rim.toFixed(tire.rim % 1 ? 1 : 0) + ' in');
        visualizer.querySelectorAll('[data-visual="' + which + '"]').forEach(function (element) {
          element.style.setProperty('--diameter-size', (tire.diameter / Math.max(stock.diameter, next.diameter) * 100).toFixed(2) + '%');
          element.style.setProperty('--rim-size', (tire.rim / tire.diameter * 100).toFixed(2) + '%');
          element.style.setProperty('--tread-width-size', (tire.width / Math.max(stock.width, next.width) * 65).toFixed(2) + '%');
        });
      });
      [20, 40, 60, 80].forEach(function (speed) {
        visualizer.querySelector('[data-speed="' + speed + '"]').textContent = (speed * next.diameter / stock.diameter).toFixed(1);
      });
      results.hidden = false;
      visualizer.hidden = false;
    }

    function compare(event, silent) {
      if (event) event.preventDefault();
      var stock = tire('stock');
      var next = tire('new');
      error.hidden = true;
      form.querySelectorAll('input').forEach(function (input) { input.removeAttribute('aria-invalid'); });

      if (!stock || !next) {
        if (silent) return;
        error.textContent = mode === 'metric'
          ? 'Enter a valid metric size, such as 225 / 60 R 17.'
          : 'Enter a valid inch size, such as 30 x 9.5 R 15.';
        error.hidden = false;
        var invalid = !stock ? inputs('stock')[0] : inputs('new')[0];
        invalid.setAttribute('aria-invalid', 'true');
        invalid.focus();
        return;
      }

      function sizeLabel(which) {
        var parts = values(which);
        return mode === 'metric' ? parts[0] + '/' + parts[1] + 'R' + parts[2] : parts[0] + 'x' + parts[1] + 'R' + parts[2];
      }
      current = { stock: stock, next: next, stockLabel: sizeLabel('stock'), newLabel: sizeLabel('new') };
      display();
    }

    form.addEventListener('submit', compare);
    form.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('input', function () {
        compare(null, true);
      });
    });

    root.querySelectorAll('[data-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        var nextMode = button.getAttribute('data-mode');
        if (nextMode === mode) return;
        saved[mode] = { stock: values('stock'), new: values('new') };
        mode = nextMode;
        root.setAttribute('data-mode', mode);
        selectButton('[data-mode]', 'data-mode', mode);
        ['stock', 'new'].forEach(function (which) {
          setValues(which, saved[mode][which]);
          var labels = mode === 'metric'
            ? ['width in millimeters', 'aspect ratio', 'wheel diameter in inches']
            : ['tire diameter in inches', 'tire width in inches', 'wheel diameter in inches'];
          inputs(which).forEach(function (input, index) {
            input.setAttribute('aria-label', (which === 'stock' ? 'Size 1 ' : 'Size 2 ') + labels[index]);
          });
        });
        root.querySelectorAll('[data-separator="first"]').forEach(function (separator) {
          separator.textContent = mode === 'metric' ? '/' : 'x';
        });
        compare();
      });
    });

    root.querySelectorAll('[data-unit]').forEach(function (button) {
      button.addEventListener('click', function () {
        unit = button.getAttribute('data-unit');
        selectButton('[data-unit]', 'data-unit', unit);
        display();
      });
    });

    saved.metric = { stock: values('stock'), new: values('new') };
    compare();

    var guide = root.parentElement.querySelector('.adf-tire-guide');
    if (!guide) return;
    guide.querySelectorAll('.adf-fitment-matrix tbody tr').forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (cells.length < 4) return;
      var stockSize = cells[1].textContent.match(/\b\d{3}\/\d{2}R\d{2}\b/i);
      var newSize = cells[3].textContent.match(/\b\d{3}\/\d{2}R\d{2}\b/i);
      if (!stockSize || !newSize) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'adf-calc-row-button';
      button.textContent = 'Compare';
      button.title = 'Compare the first listed stock and recommended tire sizes';
      button.setAttribute('aria-label', 'Compare first listed tire sizes for ' + cells[0].textContent.trim());
      button.addEventListener('click', function () {
        if (mode !== 'metric') root.querySelector('[data-mode="metric"]').click();
        setValues('stock', stockSize[0].match(/^(\d{3})\/(\d{2})R(\d{2})$/i).slice(1));
        setValues('new', newSize[0].match(/^(\d{3})\/(\d{2})R(\d{2})$/i).slice(1));
        compare();
        root.scrollIntoView({ block: 'start' });
      });
      var fitment = document.createElement('div');
      fitment.className = 'adf-calc-row-fitment';
      var sizes = document.createElement('span');
      sizes.className = 'adf-calc-row-sizes';
      while (cells[3].firstChild) sizes.appendChild(cells[3].firstChild);
      fitment.appendChild(sizes);
      fitment.appendChild(button);
      cells[3].appendChild(fitment);
    });
  }

  function initAll() {
    document.querySelectorAll('.adf-tire-calculator').forEach(initCalculator);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
